// extracted by mini-css-extract-plugin
module.exports = {"container":"ComingSoonText_container__2fHYd","full":"ComingSoonText_full__2_4Od","behind":"ComingSoonText_behind__yIFFL"};